enum EnumColor {
  LightBlue = 'light-blue',
  LightYellow = 'light-yellow',
  LightRed = 'light-red',
}

export default EnumColor;
